import React from 'react';
import { Box, Flex, Heading, Link, Image, useToast } from '@chakra-ui/core';
import { connect } from 'react-redux';

import Footer2 from './Footer2';

//?images
import logo from '../../images/logo.png';
import phone from '../../images/phone.png';
import yakool from '../../images/yakool-button.png';

function Footer(props) {
  const toast = useToast();

  React.useEffect(() => {
    if (!props.location.latitude) {
      toast({
        title: "L'emplacement est bloqué",
        description:
          "Veuillez autoriser l'emplacement pour une meilleure expérience sur le site Web",
        status: 'warning',
        duration: null,
        isClosable: true,
      });
    }
  }, []);
  return (
    <Box>
      <Flex
        pl="5%"
        pr="5%"
        mb="50px"
        mt="50px"
        direction={['column', 'column', 'row', 'row']}
        justifyContent="space-between"
        position="relative"
      >
        <Box
          w={['100%', '100%', '100%', '100%']}
          bg="black"
          alignContent="center"
          textAlign="left"
          p="30px"
          flexGrow="3"
          roundedBottomRight="20px"
          roundedTopRight="20px"
          shadow="lg"
        >
          <Flex
            justifyContent="space-between"
            direction={['column', 'column', 'row', 'row']}
          >
            <Box w={['100%', '70%']}>
              <Image m="4" w="200px" src={logo}></Image>
              <Heading color="white" size="md">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. A
                tempora iste ipsam, quae voluptates voluptatem dolor ipsa
                suscipit beatae reprehenderit esse eum nisi id
              </Heading>
            </Box>
            <Image
              mr="-100px"
              className="phone-image"
              //   m={['0 auto', '0', '0', '0']}
              w={['100%', '35%']}
              src={phone}
              alt="phone"
            ></Image>
          </Flex>
        </Box>

        <Box textAlign="center" p="30px">
          <Heading fontFamily="Rubik Mono One" mb="4" size="lg">
            COMMANDEZ AUSSI AVEC L’APPLI MOBILE
          </Heading>
          <Flex justifyContent="center">
            <Flex
              mt="10px"
              m="0 auto"
              direction="column"
              w="100%"
              justify="center"
            >
              <Link>
                <Box
                  w={['100%', '100%', '60%', '60%']}
                  bg="black"
                  m="0 auto"
                  mb="18px"
                  border="1px solid #ddd"
                  rounded="10px"
                  shadow="lg"
                >
                  <svg
                    className="apple-store"
                    style={{ display: 'inline' }}
                    width="250"
                    viewBox="0 0 2700 800"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1303 211s0-21 21-21c20 0 19 22 19 22v57h21v-57s1-40-33-40c-22 0-30 17-30 17l-1-15h-19l1 27v68h21v-58zm946 0s0-21 21-21c20 0 19 22 19 22v57h21v-57s1-40-33-40c-22 0-28 17-28 17v-58h-21v138h21v-58zm-820 423c113 0 113-200 6-200-49 0-66 36-66 36l-2-32h-38l2 43v227h43V607s13 27 55 27zm-8-166c67 0 67 133-1 133-45 0-46-47-46-47v-35s1-51 47-51zm-323-247c0-65-92-65-92 1 0 67 92 65 92-1zm-22 0c0 46-49 47-49 1 0-45 49-46 49-1zm469 0c0-65-92-65-92 1 0 67 92 65 92-1zm-22 0c0 46-49 47-49 1 0-45 49-46 49-1zm474-10s0-21 21-21c20 0 19 22 19 22v57h21v-57s1-40-33-40c-22 0-30 17-30 17l-1-15h-19l1 27v68h21v-58zM658 298s-33-51-101-51c-38 0-70 24-90 24-24 0-46-22-85-22-75 0-137 71-125 179 11 97 80 207 131 207 32 0 46-21 85-21s50 20 84 20c57 0 104-101 114-135-79-32-99-147-13-201zm-93-174c-55 4-108 58-102 118 59 2 108-58 102-118zm508 506l-86-266h-53l-86 266h44l24-78h87l24 78h46zm-78-111h-71l35-117zm213 115c113 0 113-200 6-200-49 0-66 36-66 36l-2-32h-38l2 46v224h43V607s13 27 55 27zm-8-166c68 0 68 133-1 133-45 0-46-47-46-47v-35s1-51 47-51zm465 166c55 0 96-27 96-79 0-42-30-63-67-78-24-10-51-20-51-47 0-23 21-35 46-35 29 0 51 12 51 12l11-34s-22-13-61-13c-49 0-90 28-90 75 0 33 23 59 70 76 26 9 48 21 48 48s-22 40-51 40c-37 0-61-17-61-17l-10 35s21 17 69 17zm148-67c0 43 15 67 54 67 21 0 33-5 33-5l-1-32s-8 2-19 2c-17 0-25-12-25-36v-93h47v-32h-47v-48l-42 13v35h-28v32h28v97zm301-34c0-133-188-134-188 3 0 133 188 131 188-3zm-44 1c0 92-101 93-101 1 0-91 101-93 101-1zm124-10s1-50 45-50c7 0 13 1 13 1v-40s-6-1-10-1c-42 0-53 43-53 43l-2-39h-37l1 41v151h43V524zm174 110c37 0 64-12 64-12l-6-30s-19 9-52 9c-63 0-60-57-60-57h128c6-60-18-110-79-110-65 0-90 57-90 102 0 52 29 98 95 98zm-54-120c0-10 10-51 46-51 45 0 42 51 42 51h-88zM981 200c0-42-26-63-71-63-20 0-36 3-36 3v128s18 2 30 2c48 0 77-23 77-70zm-22 1c0 33-17 52-50 52-9 0-15-1-15-1v-97s10-1 17-1c32 0 48 16 48 47zm296-27h-20l-19 75-20-75h-17l-22 75-17-75h-21l28 95h20l20-70 19 70h20zm146 95h21V131h-21v138zm168-26c0 31 41 37 57 15l2 11h19l-2-18v-40c0-26-12-39-37-39-20 0-32 8-32 8l4 14s9-7 25-7c14 0 19 7 19 21-28-1-55 9-55 35zm21-2c0-23 35-19 35-19v14c0 22-35 28-35 5zm125 30c24 0 31-17 31-17l1 15h19s-1-14-1-26V131h-21v54s-7-13-27-13c-54 0-56 99-2 99zm7-82c22 0 22 24 22 24v16s0 25-23 25c-32 0-34-65 1-65zm223 32c0-65-92-65-92 1 0 67 92 65 92-1zm-22 0c0 46-49 47-49 1 0-45 49-46 49-1zm232 17c0 20 8 33 26 33 12 0 17-3 17-3l-1-16s-3 1-9 1c-8 0-12-5-12-17v-46h23v-16h-23v-23l-21 6v17h-14v16h14v48zm232 32c20 0 32-5 32-5l-3-15s-8 4-26 4c-31 0-30-27-30-27h63c5-23-6-55-38-55-29 0-45 25-45 51 0 24 13 47 47 47zm-27-58s2-25 23-25c23 0 21 25 21 25h-44z"></path>
                  </svg>
                </Box>
              </Link>
              <Link>
                <Box
                  m="0 auto"
                  w={['100%', '100%', '60%', '60%']}
                  bg="black"
                  border="1px solid #ddd"
                  rounded="10px"
                  shadow="lg"
                >
                  <svg
                    className="google-play"
                    style={{ display: 'inline' }}
                    width="250"
                    viewBox="0 0 2700 800"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M499 400L235 600c-8-3-14-12-14-25V226c0-14 6-23 15-26l263 200z"
                      fill="url(#goo1)"
                    ></path>{' '}
                    <path
                      d="M499 466L258 597c-9 5-17 5-23 3l211-213 53 79z"
                      fill="url(#goo2)"
                    ></path>{' '}
                    <path
                      d="M236 200c6-2 14-1 22 4l240 131-53 77-209-212z"
                      fill="url(#goo3)"
                    ></path>{' '}
                    <path
                      d="M498 335l85 46c20 11 20 28 0 39l-84 46-66-66 65-65z"
                      fill="url(#goo4)"
                    ></path>{' '}
                    <path d="M1293 264c35 0 61-27 61-61 0-35-27-62-61-62s-61 28-61 62 27 61 61 61zm0-14c-26 0-45-21-45-47s19-48 45-48 46 22 46 48-20 47-46 47zm-14 373c50 0 89-38 89-88s-39-89-89-89-89 39-89 89 39 88 89 88zm0-35c-28 0-50-24-50-53 0-30 21-54 50-54 30 0 50 23 50 54 0 29-22 53-50 53zm240 13v15c0 32-16 51-47 51-34 0-44-31-44-31l-34 14s19 52 78 52c54 0 84-35 84-92V452h-37v15c-7-10-26-21-47-21-47 0-85 41-85 89 0 47 38 88 85 88 21 0 39-9 47-22zm1030-156c0-1-46-1-46-1l-47 118-51-118-44 1 74 167-41 87h44l111-254zm-244 150h2v24h39V514c0-54-38-80-84-80-56 0-73 41-73 41l34 16s10-21 39-21c21 0 44 13 44 39-32-18-123-13-123 53 0 49 49 63 68 63 25 0 41-10 54-30zm-570 28c35 0 60-19 74-39l-31-20s-12 24-43 24c-19 0-34-9-43-27l118-49c-11-33-36-66-79-66-49 0-84 39-84 89s38 88 88 88zm-650 0c50 0 89-38 89-88s-39-89-89-89-89 39-89 89 39 88 89 88zm-233 0c80 0 140-60 126-150H852v38h89c-5 47-40 74-89 74-56 0-99-44-99-99 0-57 44-100 99-100 26 0 48 9 67 27l27-27c-27-24-58-38-94-38-75 0-140 62-140 138s64 137 140 137zm1299-4V361h-39v258h39zm-156-258h-90v258h39V519h51c48 0 83-32 83-79s-35-79-83-79zm-370 257V358h-39v260h39zm-150-30c-29 0-49-24-49-53 0-30 20-54 49-54s47 24 47 54c0 29-19 53-47 53zm-390 0c-28 0-50-24-50-53 0-30 21-54 50-54 30 0 50 23 50 54 0 29-22 53-50 53zm1171-2c-14 0-32-6-32-23 0-36 65-36 83-19 0 10-19 42-51 42zm-571-54c0-35 28-52 47-52 12 0 27 6 33 19l-80 33zm311-133c27 0 42 23 42 41s-13 41-42 41h-52v-82h52zM843 199h-58v14h43c-1 23-20 37-43 37-25 0-46-20-46-47 0-30 23-48 46-48s33 14 33 14l10-10s-13-18-43-18c-34 0-61 27-61 62 0 33 26 61 61 61 34 0 63-25 58-65zm544 63v-97l60 97h16V144h-15v69l1 23h-1l-57-92h-19v118h15zm-198-104v-14h-81v14h33v104h15V158h33zm-97 104V144h-15v118h15zm-67-104v-14h-81v14h33v104h15V158h33zm-94 0v-14h-69v118h69v-15h-54v-37h49v-14h-49v-38h54z"></path>{' '}
                    <defs>
                      {' '}
                      <linearGradient id="goo1" gradientTransform="rotate(90)">
                        <stop offset="0%" stopColor="#3588b7"></stop>
                        <stop offset="100%" stopColor="#66ffd4"></stop>
                      </linearGradient>{' '}
                      <linearGradient id="goo2">
                        <stop offset="0%" stopColor="#9635c2"></stop>
                        <stop offset="100%" stopColor="#e3424f"></stop>
                      </linearGradient>{' '}
                      <linearGradient id="goo3">
                        <stop offset="0%" stopColor="#60cab6"></stop>
                        <stop offset="100%" stopColor="#d6ffa2"></stop>
                      </linearGradient>{' '}
                      <linearGradient id="goo4" gradientTransform="rotate(45)">
                        <stop offset="0%" stopColor="#ff9877"></stop>
                        <stop offset="100%" stopColor="#ffc466"></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </Box>
              </Link>
              <Flex mt="4" justifyContent="center">
                <Image
                  float="right"
                  w="100px"
                  src={yakool}
                  alt="yakool"
                ></Image>
              </Flex>
            </Flex>
          </Flex>
        </Box>
        {/* <Box flexGrow="1">section4</Box>
        <Box flexGrow="1">section5</Box> */}
      </Flex>
      <Footer2></Footer2>
      <Box fontSize="24px" color="white" bg="black" p="10px">
        <Flex justifyContent="center" fontSize="lg">
          &copy; Copyright 2020
        </Flex>
      </Box>
      {/* <Box
        textAlign="center"
        fontSize="18px"
        color="white"
        bg="linear-gradient(to right, #ad5389, #3c1053)"
        p="10px"
      >
        Developed by DevCloud
      </Box> */}
    </Box>
  );
}

const mapStateToProps = state => {
  return {
    location: state.location,
  };
};

export default connect(mapStateToProps)(Footer);
